// Module
var code = `<div class="alert">
    <span>
      <strong>DISCLAIMER:</strong> This form can be used to trigger recalculation of EIR
    </span>
</div>

<ng-form name="\$ctrl.form">
  <div class="filters">
    <div class="labelled-field labelled-field--long">
      <label for="input-selector-mode" class="add-on">Update EIR By:</label>
      <select id="input-selector-mode"
              ng-model="\$ctrl.productSelectionMode"
              ng-options="selectionMode.value as selectionMode.label for selectionMode in \$ctrl.productSelectionModes"
              ng-change="\$ctrl.resetLoanList()"
              required>
      </select>
    </div>

    <div class="labelled-field labelled-field--long"
         ng-if="\$ctrl.productSelectionMode === 'BRANCH'">
      <label for="filter-branch" class="add-on">Branch</label>
      <branch-filter
        ng-if="\$ctrl.availableBranches"
        id="filter-branch"
        ng-model="\$ctrl.branchIds"
        options="\$ctrl.availableBranches"
        ng-change="\$ctrl.onBranchChange()"
        class="form-control"
        ng-required="true"
        ng-model-options="{ allowInvalid: true }"
      >
      </branch-filter>
    </div>
    <div class="labelled-field labelled-field--long"
          ng-if="\$ctrl.productSelectionMode === 'PRODUCT_NUMBER'">
      <label for="product-number" class="add-on">Product number</label>
      <input
        id="product-number"
        ng-model="\$ctrl.searchProductNumber"
        type="text"
        autocomplete="off"
        required>
    </div>

    <button type="button"
            class="btn btn-primary"
            ng-disabled="!(\$ctrl.searchProductNumber.length > 0)"
            ng-if="\$ctrl.productSelectionMode === 'PRODUCT_NUMBER'"
            ng-click="\$ctrl.addProduct()">
      Add
    </button>
  </div>

  <div ng-if="\$ctrl.productSelectionMode === 'PRODUCT_NUMBER'">
    <table class="table">
      <thead>
      <tr>
        <th>Product number</th>
        <th>EIR Annual</th>
        <th>EIR Periodic</th>
        <th></th>
      </tr>
      <tbody>
      <tr ng-repeat="loan in \$ctrl.loansToRecalculate">
        <td>{{loan.productNumber}}</td>
        <td>{{loan.eirAnnual}}</td>
        <td>{{loan.eirPeriodic}}</td>
        <td>
          <button type="button"
                  class="btn btn-danger"
                  ng-click="\$ctrl.removeLoan(\$index)">
            Remove
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div ng-if="\$ctrl.loansToRecalculate.length > 0 || \$ctrl.branchIds.length > 0" class="flex-end">
    <button
      type="button"
      class=" btn btn-success"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</ng-form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/recalculate-loan-eir/recalculate-loan-eir.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;